// Tabela de "informações necessárias" (usada em cada semana e em "Antes de começar").
import { useState } from 'react';
import { Button, Form, Input, Modal, Select, Table, Tag, Typography } from 'antd';
import { salvarInformacao, type Informacao, type StatusInfo } from './api';
import { nomeDoPapel, type Contexto } from './comum';
import { podeMudarInformacao, ROTULO_FONTE, ROTULO_INFO } from './regras';

const { Text } = Typography;
const OPCOES_STATUS = (Object.keys(ROTULO_INFO) as StatusInfo[]).map((v) => ({ value: v, label: ROTULO_INFO[v] }));

export default function InformacoesTabela({ itens, ctx }: { itens: Informacao[]; ctx: Contexto }) {
  const { dados, salvar } = ctx;
  const [edit, setEdit] = useState<Informacao | null>(null);
  const [form] = Form.useForm<{ link: string; observacao: string }>();
  const [gravando, setGravando] = useState(false);

  if (!itens.length) return <Text type="secondary">Nada a levantar aqui.</Text>;

  const abrir = (i: Informacao) => { setEdit(i); form.setFieldsValue({ link: i.link || '', observacao: i.observacao || '' }); };
  const gravar = async () => {
    if (!edit) return;
    const v = form.getFieldsValue();
    setGravando(true);
    const ok = await salvar(() => salvarInformacao(edit.id, edit.revisao, { link: v.link?.trim() || null, observacao: v.observacao?.trim() || null }), 'Salvo.');
    setGravando(false);
    if (ok) setEdit(null);
  };

  return (
    <>
      <Table<Informacao>
        size="small" pagination={false} rowKey="id" dataSource={itens} scroll={{ x: 'max-content' }}
        columns={[
          {
            title: 'Informação', dataIndex: 'item',
            render: (_, i) => (
              <div>
                <div>{i.item}</div>
                {i.observacao && <Text type="secondary" style={{ fontSize: 12 }}>{i.observacao}</Text>}
              </div>
            ),
          },
          {
            title: 'De onde vem', width: 220,
            render: (_, i) => (
              <div>
                <Tag color={ROTULO_FONTE[i.fonte]?.cor}>{ROTULO_FONTE[i.fonte]?.texto || i.fonte}</Tag>
                {i.onde && <div style={{ fontSize: 12, color: '#8c8c8c' }}>{i.onde}</div>}
              </div>
            ),
          },
          { title: 'Responsável', width: 220, render: (_, i) => nomeDoPapel(dados, i.papel_responsavel) },
          {
            title: 'Situação', width: 160,
            render: (_, i) => podeMudarInformacao(dados.permissoes, i)
              ? (
                <Select
                  size="small" style={{ width: 140 }} showSearch optionFilterProp="label" options={OPCOES_STATUS} value={i.status}
                  onChange={(v) => { void salvar(() => salvarInformacao(i.id, i.revisao, { status: v })); }}
                />
              )
              : <Tag>{ROTULO_INFO[i.status] || i.status}</Tag>,
          },
          {
            title: 'Link', width: 150,
            render: (_, i) => (
              <span>
                {i.link ? <a href={i.link} target="_blank" rel="noreferrer">Abrir</a> : <Text type="secondary">—</Text>}
                {podeMudarInformacao(dados.permissoes, i) && <Button type="link" size="small" onClick={() => abrir(i)}>Editar</Button>}
              </span>
            ),
          },
        ]}
      />
      <Modal
        open={!!edit} title={edit?.item} onCancel={() => setEdit(null)} onOk={gravar} okText="Salvar" cancelText="Cancelar"
        confirmLoading={gravando} width="94vw" style={{ maxWidth: 640, top: 16 }} destroyOnHidden
      >
        <Form form={form} layout="vertical">
          <Form.Item name="link" label="Link (planilha, pasta, tela do ERP)"><Input placeholder="Cole o endereço aqui" /></Form.Item>
          <Form.Item name="observacao" label="Observação"><Input.TextArea rows={3} /></Form.Item>
        </Form>
      </Modal>
    </>
  );
}
